import React from 'react';
import UIRegions from 'shared/constants/UIRegions';
import Modal from 'shared/components/misc/modal.jsx';
import PDFPresetForm from 'main/components/show/cuesheet.printable/pdfExportForm/pdfPresetForm.jsx';

/**
 * Create PDF Preset Modal
 */
export default React.createClass({
  displayName: 'CreatePDFPresetModal',

  render() {
    return (
      <Modal
        className="modal-generic-wrapper create-pdf-preset-modal"
        headerClassName="modal-generic-header"
        name={UIRegions.CreatePDFPresetModal}
        title="Create new preset"
      >
        <PDFPresetForm />
      </Modal>
    );
  },
});
